<template>
  <IconLucideTrash2 />
</template>
